import { Link } from "react-router-dom";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

/**
 * Consolidated footer navigation — four clean, logically grouped columns.
 */
export function FooterNavLinks() {
  return (
    <>
      <div>
        <h4 className="font-serif text-white text-base mb-5">Expertise</h4>
        <ul className="space-y-2.5 text-sm text-primary-foreground/65">
          <li>
            <Link
              to="/loans/commercial-loans-phoenix"
              className="hover:text-accent transition-colors"
            >
              Commercial Loans
            </Link>
          </li>
          <li>
            <Link
              to="/loans/sba-loans-phoenix-scottsdale"
              className="hover:text-accent transition-colors"
            >
              SBA Loans
            </Link>
          </li>
          <li>
            <Link
              to="/loans/business-line-of-credit-arizona"
              className="hover:text-accent transition-colors"
            >
              Business Line of Credit
            </Link>
          </li>
          <li>
            <Link
              to="/loans/commercial-real-estate-arizona"
              className="hover:text-accent transition-colors"
            >
              Commercial Real Estate
            </Link>
          </li>
          <li>
            <Link
              to="/loans/equipment-financing-contractors"
              className="hover:text-accent transition-colors"
            >
              Equipment Financing
            </Link>
          </li>
          <li>
            <Link
              to="/business-succession-planning"
              className="hover:text-accent transition-colors"
            >
              Business Succession
            </Link>
          </li>
          <li>
            <Link
              to="/executive-retention-planning"
              className="hover:text-accent transition-colors"
            >
              Executive Benefits
            </Link>
          </li>
          <li>
            <Link
              to="/business-owner-trust-coordination"
              className="hover:text-accent transition-colors"
            >
              Estate &amp; Legacy
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-serif text-white text-base mb-5">Resources</h4>
        <ul className="space-y-2.5 text-sm text-primary-foreground/65">
          <li>
            <Link
              to="/tools-assessments"
              className="hover:text-accent transition-colors"
            >
              Interactive Tools &amp; Assessments
            </Link>
          </li>
          <li>
            <Link to="/portal" className="hover:text-accent transition-colors">
              Resource Library
            </Link>
          </li>
          <li>
            <Link
              to="/case-studies"
              className="hover:text-accent transition-colors"
            >
              Case Studies
            </Link>
          </li>
          <li>
            <Link
              to="/insights"
              className="hover:text-accent transition-colors"
            >
              Expert Insights
            </Link>
          </li>
          <li>
            <Link to="/faq" className="hover:text-accent transition-colors">
              FAQ
            </Link>
          </li>
          <li>
            <Link to="/pricing" className="hover:text-accent transition-colors">
              How We Work
            </Link>
          </li>
          <li>
            <Link
              to="/portal?mode=login"
              className="hover:text-accent transition-colors"
            >
              Exclusive Access
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-serif text-white text-base mb-5">Company</h4>
        <ul className="space-y-2.5 text-sm text-primary-foreground/65">
          <li>
            <Link
              to="/about-anthony-damato"
              className="hover:text-accent transition-colors text-accent font-medium"
            >
              About Anthony D&apos;Amato
            </Link>
          </li>
          <li>
            <Link
              to="/founders-message"
              className="hover:text-accent transition-colors"
            >
              Founder&apos;s Message
            </Link>
          </li>
          <li>
            <Link
              to="/strategic-partnerships"
              className="hover:text-accent transition-colors"
            >
              Strategic Partnerships
            </Link>
          </li>
          <li>
            <Link to="/reviews" className="hover:text-accent transition-colors">
              Client Reviews
            </Link>
          </li>
          <li>
            <Link
              to="/news-updates"
              className="hover:text-accent transition-colors"
            >
              News &amp; Updates
            </Link>
          </li>
          <li>
            <Link to="/brand" className="hover:text-accent transition-colors">
              Brand Style Guide
            </Link>
          </li>
          <li>
            <a
              href="https://g.page/r/review"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent transition-colors font-medium text-accent"
            >
              Leave a Google Review
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-serif text-white text-base mb-5">
          Legal &amp; Locations
        </h4>
        <ul className="space-y-2.5 text-sm text-primary-foreground/65">
          <li>
            <Link
              to="/disclosure-center"
              className="hover:text-accent transition-colors font-medium"
            >
              Disclosure Center
            </Link>
          </li>
          <li>
            <Link
              to="/where-srg-fits"
              className="hover:text-accent transition-colors"
            >
              Where SRG Fits
            </Link>
          </li>
          <li>
            <Link to="/terms" className="hover:text-accent transition-colors">
              Terms of Use &amp; Code of Ethics
            </Link>
          </li>
          <li>
            <Link to="/privacy" className="hover:text-accent transition-colors">
              Privacy Policy
            </Link>
          </li>
          <li>
            <a
              href="https://difi.az.gov/license-search"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent transition-colors"
            >
              License Verification (19177286)
            </a>
          </li>
          <li>
            <HoverCard>
              <HoverCardTrigger asChild>
                <a
                  href="https://azcc.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent transition-colors"
                >
                  AZ Corporation Commission
                </a>
              </HoverCardTrigger>
              <HoverCardContent className="w-72">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold">
                    Arizona Corporation Commission
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    The AZCC oversees corporate filings, securities regulation,
                    and ensures the compliance of business entities operating
                    within Arizona.
                  </p>
                </div>
              </HoverCardContent>
            </HoverCard>
          </li>
          <li className="pt-1">
            <span className="text-xs text-primary-foreground/45 block mb-1.5">
              Serving
            </span>
            <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs">
              {[
                { label: "Arizona (HQ)", to: "/locations/arizona" },
                { label: "Nevada", to: "/locations/nevada" },
                { label: "Colorado", to: "/locations/colorado" },
                { label: "Utah", to: "/locations/utah" },
                { label: "Washington", to: "/locations/washington" },
                { label: "Florida", to: "/locations/florida" },
                { label: "Texas", to: "/locations/texas" },
              ].map((s) => (
                <Link
                  key={s.to}
                  to={s.to}
                  className="hover:text-accent transition-colors"
                >
                  {s.label}
                </Link>
              ))}
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}
